class Tab {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    $(".js-tab-content").hide();
    $(".js-news-tab:first").addClass("is-active");
    $(".js-tab-content:first").show();

    $(".js-news-tab").click(function(){
      $(".js-tab-content").hide();
      var index = $(this).index();
      $(".js-tab-content").eq(index).show();

      $(".js-news-tab").removeClass("is-active");
      $(this).addClass("is-active");
    });

    var windowWidth = $(window).width();
    var windowSm = 768;
    if (windowWidth <= windowSm) {
      $(".js-news-trigger").click(function(){
        $(this).next("ul").slideToggle();
        $(".js-news-tab").click(function(){
          $(this).closest('ul').slideUp();
          var newText = $(this).text();
          $(".js-news-trigger").text(newText);
        });
      });
    } else {

    }


    $(".js-tab-content").hide();
    $(".js-faq-tab:first").addClass("is-active");
    $(".js-tab-content:first").show();

    $(".js-faq-tab").click(function(){
      $(".js-tab-content").hide();
      var index = $(this).index();
      $(".js-tab-content").eq(index).show();

      $(".js-faq-tab").removeClass("is-active");
      $(this).addClass("is-active");
    });

  }
}